
const FormatoMilesFilter =  () => {
    return  (number) => {
        if (number == null || isNaN(number)) return number;
        number = Math.round(Number(number)).toString();
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };
}

export default FormatoMilesFilter;


// WEBPACK FOOTER //
// ./src/busqueda/filtros/formatomiles.filter.js